var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8455 1.6673C39.5965 1.46052 39.2938 1.32878 38.9727 1.28743C38.6516 1.24608 38.3254 1.29682 38.0321 1.43374L2.83301 17.9555V21.1524L17.6174 27.0661L27.1005 41.6559H30.2982L40.4015 3.40939C40.4834 3.09617 40.4746 2.76613 40.3762 2.4577C40.2778 2.14927 40.0937 1.87516 39.8455 1.6673ZM28.3239 38.6067L20.1727 26.0659L32.716 12.3275L30.7314 10.5155L18.0899 24.3609L5.90012 19.485L37.2635 4.76322L28.3239 38.6067Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.acb041b42959cfb5bcb781b99393c160.svg";
export { ForwardRef as ReactComponent };